var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { InstanceLoader } from '@/support/InstanceLoader';
import ErrorHandler from '@/support/ErrorHandler';
import DataTable from '@/components/data-table/DataTable';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Model as DataModel } from '@/models/Model';
import { OpeningHour } from '@/models/OpeningHour';
import { ContractHour } from '@/models/ContractHour';
import { RolesEnum } from '@/items/Roles';
let Hours = class Hours extends Vue {
    constructor() {
        super(...arguments);
        this.Model = new DataModel();
        this.hours = [];
        this.editing = {};
        this.settings = [];
    }
    get weekDays() {
        return [
            {
                key: 'monday',
                title: this.$t('weekDays.monday').toString(),
            },
            {
                key: 'tuesday',
                title: this.$t('weekDays.tuesday').toString(),
            },
            {
                key: 'wednesday',
                title: this.$t('weekDays.wednesday').toString(),
            },
            {
                key: 'thursday',
                title: this.$t('weekDays.thursday').toString(),
            },
            {
                key: 'friday',
                title: this.$t('weekDays.friday').toString(),
            },
            {
                key: 'saturday',
                title: this.$t('weekDays.saturday').toString(),
            },
            {
                key: 'sunday',
                title: this.$t('weekDays.sunday').toString(),
            },
        ];
    }
    mounted() {
        this.initialize();
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    initialize() {
        if (!this.type) {
            return;
        }
        if (this.type === 'OpeningHour' && this.$store.state.openingHours) {
            this.hours = this.$store.state.openingHours;
            this.createEditMap();
            this.fetchHours();
        }
        else {
            this.fetchHours();
        }
    }
    fetchHours() {
        this.Model = InstanceLoader.get(this.type);
        const filter = this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]) && this.user ? { user: this.user } : {};
        if (this.user) {
            this.Model.user = this.user;
        }
        this.Model
            .filter(filter)
            .sort('weekdays')
            .all()
            .then((items) => {
            if (items.length === this.weekDays.length) {
                this.hours = items;
            }
            else {
                this.hours = this.createTemporaryHours(items);
            }
            if (this.type === 'OpeningHour') {
                this.$store.dispatch('loadedOpeningHours', items);
            }
            this.createEditMap();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    createEditMap() {
        const editingMap = {};
        this.hours.forEach((item) => {
            const hour = this.parseToModel(item);
            if (!hour || !hour.id) {
                return;
            }
            editingMap[hour.id] = {
                editMode: false,
                startModal: false,
                endModal: false,
                starts_at: hour.starts_at ? this.parseTime(hour.starts_at) : '',
                ends_at: hour.ends_at ? this.parseTime(hour.ends_at) : '',
            };
        });
        this.$set(this, 'editing', editingMap);
    }
    createTemporaryHours(items) {
        if (!this.type) {
            return [];
        }
        const week = [];
        this.weekDays.forEach((day) => {
            const existing = items.find((item) => {
                return item.id === day;
            });
            if (!existing) {
                const payload = {
                    id: day.key || day,
                    starts_at: '09:00:00',
                    ends_at: '18:00:00',
                };
                if (this.type === 'OpeningHour') {
                    week.push(new OpeningHour(payload));
                }
                else if (this.type === 'ContractHour') {
                    week.push(new ContractHour(payload));
                }
            }
            else {
                week.push(existing);
            }
        });
        return week;
    }
    isClosed(hour) {
        if (!hour) {
            return true;
        }
        return hour.starts_at === '00:00:00' && hour.ends_at === '00:00:00';
    }
    setClosed(hour) {
        hour.starts_at = '00:00';
        hour.ends_at = '00:00';
        this.update(hour);
    }
    parseTime(time) {
        if (!time) {
            return '';
        }
        const parts = time.split(':');
        return `${parts[0]}:${parts[1]}`;
    }
    setOpened(openingHour) {
        openingHour.starts_at = '09:00';
        openingHour.ends_at = '18:00';
        this.update(openingHour);
    }
    setItemChanged(openingHour) {
        if (!openingHour.id) {
            return;
        }
        openingHour.starts_at = this.editing[openingHour.id].starts_at;
        openingHour.ends_at = this.editing[openingHour.id].ends_at;
        this.update(openingHour);
    }
    update(hour) {
        const payload = {
            id: hour.id,
            starts_at: hour.starts_at,
            ends_at: hour.ends_at,
        };
        if (this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.ROOT]) && this.user) {
            payload.user = this.user;
        }
        hour
            .put(payload)
            .then(() => {
            this.fetchHours();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    // public formatTime(time: string) {
    // }
    getDayById(id) {
        const hour = this.hours.find((item) => {
            return item.id === id;
        });
        if (!hour || !hour.day) {
            return null;
        }
        return hour.day;
    }
    parseToModel(item) {
        if (item.getInstanceName() === 'OpeningHour') {
            return item;
        }
        if (item.getInstanceName() === 'ContractHour') {
            return item;
        }
        return null;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], Hours.prototype, "type", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], Hours.prototype, "user", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], Hours.prototype, "role", void 0);
Hours = __decorate([
    Component({
        components: {
            DataTable,
            SelectFilter,
        },
        filters: {
            formatTime(time) {
                if (!time) {
                    return '';
                }
                if (time === '00:00:00') {
                    return '-';
                }
                const parts = time.split(':');
                return `${parts[0]}:${parts[1]}`;
            },
        },
    })
], Hours);
export default Hours;
